import { TFunction } from "i18next";
import * as Yup from "yup";

export const getTemplateFormSchema = (t: TFunction) =>
    Yup.object().shape({
        description: Yup.string()
            .trim()
            .required(t("common:form.requiredFieldForm")),
        effectiveStartDate: Yup.number()
            .nullable()
            .required(t("common:form.requiredFieldForm"))
            .moreThan(0, t("common:form.requiredFieldForm")),
        effectiveEndDate: Yup.number()
            .nullable()
            .notRequired()
            .when("effectiveStartDate", ([effectiveStartDate], schema) =>
                effectiveStartDate
                    ? schema.test(
                        "effectiveEndDate-after-effectiveStartDate",
                        t("common:form.messageErrorFinishDateBeforeStartDate"),
                        (effectiveEndDate) => {
                            if (!effectiveEndDate) return true;
                            return effectiveEndDate > effectiveStartDate;
                        }
                    )
                    : schema
            ),
        fields: Yup.array()
            .of(
                Yup.object().shape({
                    order: Yup.number()
                        .required(t("common:form.requiredFieldForm"))
                        .moreThan(0, t("common:form.valueMustBeGreatherThan", { num: 0 })),
                    extraFieldId: Yup.number()
                        .required(t("common:form.requiredFieldForm"))
                        .moreThan(0, t("common:form.requiredFieldForm")),
                    objectType: Yup.number()
                        .required(t("common:form.requiredFieldForm"))
                        .min(0, t("common:form.requiredFieldForm")),
                    originFieldName: Yup.string()
                        .trim()
                        .required(t("common:form.requiredFieldForm")),
                    description: Yup.string()
                        .trim()
                        .required(t("common:form.requiredFieldForm")),
                    showInHistorical: Yup.boolean()
                        .nullable()
                        .notRequired(),
                    historicalColumnName: Yup.string()
                        .trim()
                        .when('showInHistorical', {
                            is: true,
                            then: (schema) => schema.required(t("common:form.requiredFieldForm")),
                            otherwise: (schema) => schema.notRequired(),
                        }),
                })
            )
            .nullable()
            .notRequired(),
    });
